var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0"},[_vm._v(" En la caja de texto de abajo ingrese su "),_c('b',[_vm._v("cédula de identidad")]),_vm._v(" "),_c('span',{staticClass:"red--text"},[_vm._v("sin expedido")]),_vm._v(", vease el siguiente ejemplo: "),_c('ul',[_c('li',[_vm._v("1234567 "),_c('span',{staticClass:"blue--text"},[_vm._v("sin complemento")])])])])
}]

export { render, staticRenderFns }